// RM-399 (the product agent and Kapil, 10/21) — the group/private dining inquiry's room
// preference is multiple choice, like seating: every room type that works, stored as the
// joined string every display and email prints ("Private, Semi-Private"), in option order.
// The five earlier values ("Private Room Only", "Private Room or Semi-Private",
// "Semi-Private", "Semi-Private or Main Dining", "Interested in all Options") read as the
// options they named, so older inquiries open with the right chips and nothing stored is
// rewritten. Mirrors lib/inquiryStatus.js on the server (one rule, two runtimes).
export const ROOM_OPTIONS = ['Private', 'Semi-Private', 'Main Dining']
export const ROOM_SEPARATOR = ', '
export const SEATING_OPTIONS = ['One Large Table', 'Multiple Round', 'Cocktail Style']
export const SEATING_SEPARATOR = ', '

const LEGACY_ROOM_VALUES = {
  'private room only': ['Private'],
  'private room': ['Private'],
  'private room or semi-private': ['Private', 'Semi-Private'],
  'semi-private or main dining': ['Semi-Private', 'Main Dining'],
  'interested in all options': ROOM_OPTIONS,
}

/** The options a stored value names (the joined string or a legacy value), in option order. */
export function roomPreferencesOf(value) {
  const parts = Array.isArray(value)
    ? value.map(v => String(v || '').trim().toLowerCase()).filter(Boolean)
    : String(value || '').split(ROOM_SEPARATOR).map(v => v.trim().toLowerCase()).filter(Boolean)
  if (!parts.length) return []
  const whole = LEGACY_ROOM_VALUES[parts.join(ROOM_SEPARATOR)]
  if (whole) return [...whole]
  const named = new Set()
  for (const part of parts) {
    const legacy = LEGACY_ROOM_VALUES[part]
    if (legacy) legacy.forEach(o => named.add(o))
    const exact = ROOM_OPTIONS.find(o => o.toLowerCase() === part)
    if (exact) named.add(exact)
  }

  return ROOM_OPTIONS.filter(o => named.has(o))
}

/** The stored value for a set of options: "Private, Semi-Private" in option order, or null for none. */
export function joinRoomPreferences(options) {
  const chosen = ROOM_OPTIONS.filter(o => (options || []).includes(o))

  return chosen.length ? chosen.join(ROOM_SEPARATOR) : null
}

export function seatingPreferencesOf(value) {
  return String(value || '').split(SEATING_SEPARATOR).map(v => v.trim()).filter(Boolean)
}
